import React from 'react';
import PreLoginPage from "../core/PreLoginPage";
import couponBoxImage from "../../images/coupon/gift_box_sm.png";
import $ from 'jquery';
import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import UserStore from '../../util/UserStore';
import HmEventRegistry from '../../model/HmEventRegistry';

class CouponCodeLayout extends PreLoginPage{
    constructor(props){
        super(props)
        this.state={
            loginMaxLength:30,
            submitButtonDisabled: false,
            serverMessage:"",
            plp_userinput:'',
            valid:false,
            userAttrUpdate:false            
        }

        this.handleChange = this.handleChange.bind(this);
        this.userIdChange = this.userIdChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.autohandleSubmit = this.autohandleSubmit.bind(this);
        this.couponTrackInit = this.couponTrackInit.bind(this);
        this.autoSubmitFn = this.autoSubmitFn.bind(this);
        this.getUpdateAttribute = this.getUpdateAttribute.bind(this);
    }

    componentDidMount(){
        this.getUpdateAttribute()
    }

     /**
    * IMPORTANT:This method gets the attribute prefix based on the product catalogue.
    * If it weren't for this method, all Product Catalogue will share the same CouponCode
    */
    getAttributePrefix(){
        return (this.props.couponPrefix ? this.props.couponPrefix + "-" : "-");
    }


    getUpdateAttribute(){
        var me=this;
        let couponcode = this.getAttribute(this.getAttributePrefix()+"couponcode") || '';
        this.setState({userAttrUpdate:true,plp_userinput:couponcode})
    
        setTimeout(()=>{
            if(me.state.plp_userinput.length>0){
                    me.autohandleSubmit();
            }
        },300);

    }

   autoSubmitFn(){
    var me=this;
    let userLoggedIn = (me.getUser().getUserId() && me.getUser().getUserId().length > 0) ? true : false;
    let tempFunc = () => {
        if(typeof me.props.postLoginCallBack === "function"){
            me.props.postLoginCallBack();
        }

        userLoggedIn = (me.getUser().getUserId() && me.getUser().getUserId().length > 0) ? true : false;
        me.submitForm();
    }

    if(!userLoggedIn){
        if(typeof this.props.showSubscriptionForm === "function"){
            this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"couponcode-applybtn"});
            this.props.showSubscriptionForm(tempFunc);
        }
    }else{
        tempFunc();
    }   
}

   couponTrackInit(response){
       var me=this;
    let trackObj={
        "couponCode":me.state.plp_userinput || null,
        "valid":(response && response.status === "valid") || false
    };

    let success = function(resp){
        
                let trackId = (resp && resp.trackId) ? resp.trackId : 0;

                if(trackId > 0 && typeof me.props.setTrackId === "function"){
                    me.props.setTrackId(trackId,trackObj.valid);
                }
        
        }

    let failure = function(err){
        console.warn("Coupon Init track failed :", err);
    }

    HmEventRegistry.fireEvent("COUPON_TRACK_CREATE",trackObj,success,failure);
}

userIdChange(e){
  const target = e.currentTarget;	


  this.handleChange(e);

  this.setState({			
     submitButtonDisabled: false
 });
  $(".userlogintypeformgroup .plp_userinput.form-control").attr({'style':'border:2px solid #66666645 !important'})
  $(".userlogintypeformgroup .form-control-feedback").hide();

}

handleChange(e) {
  const target = e.currentTarget;	
  this.form.validateFields(target);

  this.setState({
    [target.name]: target.value,
    serverMessage:"",
    submitButtonDisabled: !this.form.isValid()
});
}

autohandleSubmit(){
    $(".userlogintypeformgroup .form-control-feedback").show();
    this.form.validateFields();

    this.setState({ submitButtonDisabled: !this.form.isValid() });

    if (this.form.isValid()) {  
     this.submitForm();
 }
}


submitForm = function(){

  if(this.state.plp_userinput.length<=0){
     return;
 }

 this.setState({submitButtonDisabled: true});

 var formData = {
    "couponCode":this.state.plp_userinput,
    "category":this.getUser().getUserOrigin()
}

var me =this;
var callBackSuccess = function(response){
 if(response !== null){
    console.log("response : ", response);					
    if(response.status=="valid"){
        if(response.body){
                    let callBackParent = () =>{
                        me.props.callBackParent(response.body)
                        $(".userlogintypeformgroup .plp_userinput.form-control").attr({'style':'border:2px solid #28a745 !important'})
                        me.setState({submitButtonDisabled: true, serverMessage: me.rb("couponcode.success"),valid:true});

                        $('html, body').animate({
                            scrollTop: $(".productFlipbox").offset().top
                        }, 500);
                    }
                    
                    me.setAttribute(me.getAttributePrefix()+"couponcode",formData.couponCode,callBackParent);
                        //me.removeAttribute("couponcode");
                    }
                   
                    
                }else if(response.status=="forbidden" || response.status=="failure"){
                    if(response.message=="invalid_coupon"){
                        me.setState({submitButtonDisabled: false, serverMessage: me.rb("couponcode.validpromo")});
                    }else if(response.message=="coupon_expired"){
                        me.setState({submitButtonDisabled: false, serverMessage: me.rb("couponcode.coupon_expired")});
                    }else if(response.message=="error_communicating_centa"){
                        me.setState({submitButtonDisabled: false, serverMessage: me.rb("couponcode.comm_error")});
                    }else if(response.message=="internal_error_occurred"){
                        me.setState({submitButtonDisabled: false, serverMessage: me.rb("couponcode.coupon_expired")});
                    }else{
                        if(response.message.match("max_usage_limit_reached")>-1){
                            me.setState({submitButtonDisabled: false, serverMessage:  me.rb(response.message)});
                        }else{
                            me.setState({submitButtonDisabled: false, serverMessage:  me.rb(response.message)});
                        }
                    }
                    $(".userlogintypeformgroup .plp_userinput.form-control").attr({'style':'border:2px solid #dc3545 !important'})
                }

                if(!me.props.couponCodeTracked){
                    me.couponTrackInit(response);
                }
           
            }
        }

        var callBackFailure = function(response){
         console.log("response : ", response);
           // me.trackMe(false);
           me.setState({submitButtonDisabled: false, serverMessage:  me.rb(response.message)});
           $(".userlogintypeformgroup .plp_userinput.form-control").attr({'style':'border:2px solid #dc3545 !important'})
       }

       new HmAjax(this.getUrlFor("GET_COUPON_STATUS"),formData).post(callBackSuccess,callBackFailure);
		//new UserStore().clearOldUser();
    }

handleSubmit(e) {
    e.preventDefault();
    $(".userlogintypeformgroup .plp_userinput").blur()
    $(".userlogintypeformgroup .form-control-feedback").show();
    this.form.validateFields();

    this.setState({ submitButtonDisabled: !this.form.isValid() });

    if (this.form.isValid()) {   
        this.autoSubmitFn();
    // this.submitForm();
 }
}

render(){

    
        let inputDisabled = this.props.couponApplied || false;

    return(
        <div className="CouponCodeLayout">

        <div className="nopadding coupontypeContainer">


        <div className="text-center clearfix">

        <FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
        onSubmit={this.handleSubmit} noValidate>
        <div className="row userlogintyperoot justify-content-center">
        <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 couponBox">

        <div> <img src={couponBoxImage}/><span className="coupIntro">&nbsp;{this.rb("centa.boxtitle")}&nbsp;&nbsp;</span></div>


       
        <FormGroup for="plp_userinput" className="userlogintypeformgroup">

        { (()=>{
            if(this.state.userAttrUpdate){
                return (
                   <div>
                        <FormControlInput type="plp_userinput" className={"plp_userinput userlogintype "} name="plp_userinput" placeholder={this.rb("centa.coupon.code_paceholder")}
                    pattern="^[A-Za-z0-9_]*$" value={this.state.plp_userinput} onChange={this.userIdChange} 
                    required minLength={1} maxLength={this.state.loginMaxLength} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="1" disabled={inputDisabled}/>
            
            
                    <FieldFeedbacks for="plp_userinput">
                    <FieldFeedback when="valueMissing"><i className="material-icons errinfoicon">info</i> {this.rb("couponcode.promorequired")}</FieldFeedback>
                    <FieldFeedback when="patternMismatch"><i className="material-icons errinfoicon">info</i> {this.rb("couponcode.patternmismatch")}</FieldFeedback>														
                    </FieldFeedbacks>	
                       </div>
                )
            }
        })()}
            

        {/* <div className="server-messages">{ this.state.serverMessage }</div> */}
        {(()=>{
            if(!this.state.valid){
            return (
            <div className="server-messages">{this.state.serverMessage}</div>
            )
            }else{
            return (
            <div className="server-messages success">{this.state.serverMessage}</div>
            )
            }
        })()}


        </FormGroup>




        <div>
        <button disabled={inputDisabled} data-ga={"Home - "+this.props.from+" Home- Join"} disabled={this.state.submitButtonDisabled} className="joinButton">{this.rb("couponcode.apply")}</button>
        </div>

        </div>


        </div>
        </FormWithConstraints>	
        </div>
        </div>

        </div>
        )
    }
}

export default CouponCodeLayout;


// WEBPACK FOOTER //
// ./src/views/purchase/CouponCodeLayout.js